const toLocal = state => state.work_operation_details

export function getById(state, id) {
  return toLocal(state).byId[id]
}

export function isFetching(state) {
  return toLocal(state).isFetching
}

export function getFetchingId(state) {
  return toLocal(state).fetchingId
}

export function hasError(state) {
  return Boolean(toLocal(state).lastError)
}
